function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { message, Button } from 'antd';
import Common from "./includes/Common";
import { Table, Container, Row, Col, Spinner } from 'react-bootstrap';
import { Eyedropper } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var DisplayLabReport = function DisplayLabReport(_ref) {
  var timeFrame = _ref.timeFrame;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDataLoading = _useState2[0],
      setIsDataLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      customersData = _useState4[0],
      setCustomersData = _useState4[1];

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getlabohistory/' + timeFrame[0]._d + '/' + timeFrame[1]._d + '/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCustomersData(response.data.customers);
      } else {}
    })["catch"](function (error) {})["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Table, {
      style: {
        height: '500px',
        overflow: 'scroll'
      },
      responsive: true,
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: "N.Echant."
          }), /*#__PURE__*/_jsx("th", {
            children: "Date"
          }), /*#__PURE__*/_jsx("th", {
            children: "RNC"
          }), /*#__PURE__*/_jsx("th", {
            children: "Pr\xE9nom"
          }), /*#__PURE__*/_jsx("th", {
            children: "Nom"
          }), /*#__PURE__*/_jsx("th", {
            children: "T\xE9l\xE9phone"
          }), /*#__PURE__*/_jsxs("th", {
            children: [/*#__PURE__*/_jsx(Eyedropper, {
              size: 22
            }), " ", /*#__PURE__*/_jsx("b", {
              children: "G"
            })]
          }), /*#__PURE__*/_jsxs("th", {
            children: [/*#__PURE__*/_jsx(Eyedropper, {
              size: 22
            }), " ", /*#__PURE__*/_jsx("b", {
              children: "R"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: customersData.map(function (c) {
          return /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: c.laboresult != null && c.laboresult.sampleid
            }), /*#__PURE__*/_jsx("td", {
              children: new Date(c.created_at).toLocaleDateString('Fr', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })
            }), /*#__PURE__*/_jsx("td", {
              children: c.rnc
            }), /*#__PURE__*/_jsx("td", {
              children: c.firstname
            }), /*#__PURE__*/_jsx("td", {
              children: c.lastname
            }), /*#__PURE__*/_jsx("td", {
              children: c.mobile
            }), /*#__PURE__*/_jsx("td", {
              children: c.laboresult != null && c.laboresult.group != null && c.laboresult.group
            }), /*#__PURE__*/_jsxs("td", {
              children: [c.laboresult != null && c.laboresult.rhesus != null && c.laboresult.rhesus == '+' && /*#__PURE__*/_jsx("b", {
                children: "Positif"
              }), c.laboresult != null && c.laboresult.rhesus != null && c.laboresult.rhesus == '-' && /*#__PURE__*/_jsx("b", {
                children: "N\xE9gatif"
              })]
            })]
          }, 'q' + c.id.toString());
        })
      })]
    }), isDataLoading && /*#__PURE__*/_jsx("div", {
      style: {
        textAlign: 'center'
      },
      children: /*#__PURE__*/_jsx(Spinner, {
        variant: "success",
        animation: "grow"
      })
    })]
  });
};

export default DisplayLabReport;